import { Component, OnInit,Inject,ElementRef, ViewChild } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material';


export interface DialogData {
  source: string;
}

@Component({
  selector: 'app-wave-modal',
  templateUrl: './wave-modal.component.html',
  styleUrls: ['./wave-modal.component.scss']
})
export class WaveModalComponent implements OnInit {
  change:any;
  cpt:any=0;
  @ViewChild('myDiv') myDiv: ElementRef;
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit() {
    console.log('DARA',this.data)
  }

  ngAfterViewInit() {
    // console.log('LE IFRAME',this.myDiv);
}

  onLoadFunc(event,myDiv) {
    // console.log('EVENT',event)
    // console.log('IFR',myDiv)
    if(this.change==myDiv){
      this.change=myDiv
      console.log('===egal' ,myDiv.contentWindow )
    }
    else{
      console.log('===different',myDiv.contentWindow)
      this.change=myDiv
      
    }
    // console.log('IFR DOC',myDiv.contentDocument.body)
    // console.log('IFR WIN',myDiv)
    // console.log('LE IFRAME',this.myDiv.nativeElement.contentWindow.location);
    // this.source = myIframe.contentWindow.location.href;
    // console.log('LOADER')
   
  }

}
